import React, { Component } from "react";
import apiClient from "../lib/apiClient";

class SongOrder extends Component {
  constructor() {
    super();
    this.state = {
      gigSongs: [],
      isLoading: true
    }
  }

  async componentDidMount() {
    const gigSongs = await apiClient.getVotedSongs();
    if (gigSongs) {
      return this.setState({ gigSongs, isLoading: false });
    }
  }

  handlePosition = (event) => {
    const { id } = event.target;
    const operation = id.split("_")[0]
    const songName = id.split("_")[1];
    const { gigSongs } = this.state;
    const selected = gigSongs.filter(song => song.name === songName)[0];
    const selectedIndex = gigSongs.indexOf(selected);
    const previous = gigSongs[selectedIndex - 1];
    const next = gigSongs[selectedIndex + 1];
    if (operation === "minus" && selectedIndex > 0) {
      gigSongs[selectedIndex] = previous;
      gigSongs[selectedIndex - 1] = selected;
    } else if (operation === "plus" && selectedIndex < gigSongs.length-1) {
      gigSongs[selectedIndex] = next;
      gigSongs[selectedIndex + 1] = selected;
    } 
    return this.setState({ gigSongs });
  }

  confirmChange = async () => {
    const { gigSongs } = this.state;
    await apiClient.editGig(gigSongs);
    location.href = "https://max-and-sax.netlify.app/admin";
  }

  skipChange = () => {
    location.href = "https://max-and-sax.netlify.app/admin";
  }


  render() {
    const { gigSongs, isLoading } = this.state;
  
		if (isLoading) {
			return <div>loading ... </div>;
		}
		
    return (
      <div className="main h-2/3 flex flex-col items-center justify-start">
      <p className="text-2xl py-5">Vols canviar l`ordre dels temes?</p>
      <form className="pb-5">
        {gigSongs.map((song, index) => <div key={index}>
          <p >
            {song.name} - {song.artist}
            <span className="text-3xl" id={`minus_${song.name}`} value={song.name} onClick={this.handlePosition}>     ↑   </span>
            <span className="text-3xl" id={`plus_${song.name}`} onClick={this.handlePosition}>↓</span>
          </p>
        </div>)}
        </form>
        <div className="flex w-96 justify-between ">
          <button className="button" onClick={this.confirmChange}>Confirma canvis</button>
          <button className="redbutton" onClick={this.skipChange}>Passa de llarg</button>
        </div>
      </div>
    )
  }
}

export default SongOrder;